import iconDictionary from '../../utils/iconDictionary';

export const UNAVAILABLE_LOAN_ILLUSTRATION_DICT = {
  errorPorchlight: iconDictionary('errorPorchlight'),
  welcomeHome: iconDictionary('welcomeHome'),
};
